const eventData = {
    tank: [
        'highLevel',
        'highLevelDelta',
        'criticalLevel',
        'criticalLevelDelta',
        'rapidIncrease',
        'rapidIncreaseDelta',
        'rapidDecrease',
        'rapidDecreaseDelta',
        'inchesToBarrels',
        'inchesToBarrelsDelta',
        'correctionFactor',
        'correctionFactorDelta',
        'sizeInInches',
        'sizeInInchesDelta',
        'topLevel',
        'topLevelDelta',
        'waterLevel',
        'waterLevelDelta',
        'temperature',
        'temperatureDelta',
        'voltage',
        'voltageDelta',
    ],
    toptech: [
        // 'EndDate',
        'HaulerCoPermitNo',
        // 'StartEpochTime',
        'TransactionNotes',
        'SWDTransactionID',
        // 'StartTime',
        // 'EndTime',
        'HaulerCoID',
        'UploadTimestamp',
        'TotalCharge',
        'ServiceTicketNo',
        'WellLeaseID',
        'Volume',
        // 'StopEpochTime',
        'MaterialName',
        'TruckNumber',
        // 'TotalTime',
        'SWDSiteLaneID',
        'SWDSiteID',
        'TransKey',
        'DisposalTicketNo',
        // 'StartDate',
        'TruckDriverName',
    ],
    gps: [
        // { label: 'time', value: 'time.value' },
        { label: 'lat', value: 'lat.value' },
        { label: 'long', value: 'long.value' },
        { label: 'fix', value: 'fix.value' },
        { label: 'satNum', value: 'satNum.value' },
        { label: 'HDOP', value: 'HDOP.value' },
        { label: 'altitude', value: 'altitude.value' },
        { label: 'valid', value: 'valid.value' },
        { label: 'speed', value: 'speed.value' },
        { label: 'trueCourse', value: 'trueCourse.value' }
    ],
    lpr: [
        'plate',
        // 'date',
        'country',
        'state',
        'confidence',
        // 'left', // not useful?
        // 'top',
        // 'right',
        // 'bottom',
        'charheight',
        'processingtime',
        'speed',
        'direction'
    ],
    thermalTank: {
        update: [
            'validZones'
        ],
        detail: [
            { label: 'Size', value: 'analytics.size' },
            { label: 'Min', value: 'analytics.min' },
            { label: 'Max', value: 'analytics.max' },
            { label: 'Average', value: 'analytics.avg' },
        ]
    },
    accessControl: {
        access: [
            'user'
        ],
        doorMode: [
            'doorAlarm',
            'doorMode'
        ],
        doorModePhysical: [
            'doorAlarm',
            'doorMode',
            'doorModePhysicalState'
        ],
        invalidPin: [
            'doorAlarm',
            'doorMode',
            'pin'
        ],
        denied: [
            'doorAlarm',
            'doorMode',
            'card'
        ]
    },
    camera: {
        restarted: [
            'reason',
            'userInitiated'
        ],
        rotation: [
            'rotation'
        ],
        profileSettings: [
            'resolution',
            'compression',
            'mirror',
            'fps',
            'audio',
            'maxFrameSize',
            'h264profile',
            'videoCodec',
            'videoKeyFrameInterval'
        ],
        zoom: [
            'zoom'
        ],
        missingVideo: [
            'reason',
            'count'
        ],
        offline: [
            { label: 'uptimeSeconds', value: 'status.uptimeSeconds' },
        ]
    },
    earthquake: [
        'mag'
    ],
    nvr: [
        'numberOfCameras'
    ],
    padlock: [
        'user',
        'latitude',
        'longitude',
        'firmware',
        'battery'
    ],
    speaker: [
        'clip',
        'clipName'
    ],
    ticketingSwd: [
        'truckDriverName',
        'materialName',
        'volume'
    ],
};
const supportedEventConditions = {
    'accessControls/doorModeUnlocked': {
        eventName: 'accessControls/doorModeUnlocked',
        title: 'Door Mode Unlocked',
        eventData: eventData.accessControl.doorMode
    },
    'accessControls/doorModeLocked': {
        eventName: 'accessControls/doorModeLocked',
        title: 'Door Mode Locked',
        eventData: eventData.accessControl.doorMode
    },
    'accessControls/doorModeAccessed': {
        eventName: 'accessControls/doorModeAccessed',
        title: 'Door Mode Accessed',
        eventData: eventData.accessControl.doorMode
    },
    'accessControls/doorModeUnknown': {
        eventName: 'accessControls/doorModeUnknown',
        title: 'Door Mode Unknown',
        eventData: eventData.accessControl.doorMode
    },
    'accessControls/doorModeDoubleLocked': {
        eventName: 'accessControls/doorModeDoubleLocked',
        title: 'Door Mode Double Locked'
    },
    'accessControls/doorModeLockedDown': {
        eventName: 'accessControls/doorModeLockedDown',
        title: 'Door Mode Double Locked Down'
    },
    'accessControls/doorModeLockedOpen': {
        eventName: 'accessControls/doorModeLockedOpen',
        title: 'Door Mode Double Locked Open'
    },
    'accessControls/doorModeBlocked': {
        eventName: 'accessControls/doorModeBlocked',
        title: 'Door Mode Blocked',
        eventData: eventData.accessControl.doorMode
    },
    'accessControls/doorPhysicalStateOpen': {
        eventName: 'accessControls/doorPhysicalStateOpen',
        title: 'Door Physical State Open',
        eventData: eventData.accessControl.doorModePhysical
    },
    'accessControls/doorPhysicalStateClosed': {
        eventName: 'accessControls/doorPhysicalStateClosed',
        title: 'Door Physical State Closed',
        eventData: eventData.accessControl.doorModePhysical
    },
    'accessControls/doorPhysicalStateUnknown': {
        eventName: 'accessControls/doorPhysicalStateUnknown',
        title: 'Door Physical State Unknown'
    },
    'accessControls/doorPhysicalStateFault': {
        eventName: 'accessControls/doorPhysicalStateFault',
        title: 'Door Physical State Fault',
        eventData: eventData.accessControl.doorModePhysical
    },
    'accessControls/doorPhysicalStateNotSupported': {
        eventName: 'accessControls/doorPhysicalStateNotSupported',
        title: 'Door Physical State Not Supported',
        eventData: eventData.accessControl.doorModePhysical
    },
    'accessControls/doorAlarmDoorForcedOpen': {
        eventName: 'accessControls/doorAlarmDoorForcedOpen',
        title: 'Door Forced Open',
        eventData: eventData.accessControl.doorModePhysical
    },
    'accessControls/doorAlarmDoorOpenTooLong': {
        eventName: 'accessControls/doorAlarmDoorOpenTooLong',
        title: 'Door Open Too Long',
        eventData: eventData.accessControl.doorModePhysical
    },
    'accessControls/doorAlarmNormal': {
        eventName: 'accessControls/doorAlarmNormal',
        title: 'Door Alarm Normal',
        eventData: eventData.accessControl.doorModePhysical
    },
    'accessControls/access': {
        eventName: 'accessControls/access',
        title: 'Access Success',
        eventData: eventData.accessControl.access
    },
    'accessControls/pin': {
        eventName: 'accessControls/pin',
        title: 'Pin',
        eventData: eventData.accessControl.doorModePhysical
    },
    'accessControls/invalidPin': {
        eventName: 'accessControls/invalidPin',
        title: 'Invalid pin',
        eventData: eventData.accessControl.invalidPin
    },
    'accessControls/denied': {
        eventName: 'accessControls/denied',
        title: 'Access Denied',
        eventData: eventData.accessControl.denied
    },
    'accessControls/acknowledgement': {
        eventName: 'accessControls/acknowledgement',
        title: 'accessControls/acknowledgement'
    },
    'cameras/cameraAutofocused': {
        eventName: 'cameras/cameraAutofocused',
        title: 'Camera Auto Focused'
    },
    'cameras/cameraFocused': {
        eventName: 'cameras/cameraFocused',
        title: 'Camera Focused'
    },
    'cameras/cameraMotionStarted': {
        eventName: 'cameras/cameraMotionStarted',
        title: 'Camera Motion Started'
    },
    'cameras/cameraMotionFinished': {
        eventName: 'cameras/cameraMotionFinished',
        title: 'Motion Detected'
    },
    'cameras/motion': {
        eventName: 'cameras/motion',
        title: 'Motion Detected'
    },
    'cameras/motionNotification': {
        eventName: 'cameras/motionNotification',
        title: 'Motion Occurring'
    },
    'cameras/cameraMotionZoneSet': {
        eventName: 'cameras/cameraMotionZoneSet',
        title: 'Camera Motion Zone Set'
    },
    'cameras/cameraMotionZoneEnabled': {
        eventName: 'cameras/cameraMotionZoneEnabled',
        title: 'Camera Motion Zone Enabled'
    },
    'cameras/cameraMotionZoneDisabled': {
        eventName: 'cameras/cameraMotionZoneDisabled',
        title: 'Camera Motion Zone Disabled'
    },
    'cameras/cameraReachable': {
        eventName: 'cameras/cameraReachable',
        title: 'Camera Reachable'
    },
    'cameras/cameraReset': {
        eventName: 'cameras/cameraReset',
        title: 'Camera Reset'
    },
    'cameras/cameraRestarted': {
        eventName: 'cameras/cameraRestarted',
        title: 'Camera Restarted',
        eventData: eventData.camera.restarted
    },
    'cameras/shareTestFailed': {
        eventName: 'cameras/shareTestFailed',
        title: 'Camera Network Share Test Failed'
    },
    'cameras/shareTestBackoff': {
        eventName: 'cameras/shareTestBackoff',
        title: 'Camera Network Share Test Backoff'
    },
    'cameras/cameraRotationSet': {
        eventName: 'cameras/cameraRotationSet',
        title: 'Camera Rotation Set',
        eventData: eventData.camera.rotation
    },
    'cameras/cameraSnapshot': {
        eventName: 'cameras/cameraSnapshot',
        title: 'Snapshot taken'
    },
    'cameras/cameraStreamProfileSettingsSet': {
        eventName: 'cameras/cameraStreamProfileSettingsSet',
        title: 'Camera Stream Profile Settings Set',
        eventData: eventData.camera.profileSettings
    },
    'cameras/cameraUnreachable': {
        eventName: 'cameras/cameraUnreachable',
        title: 'Camera Unreachable'
    },
    'cameras/cameraZoomed': {
        eventName: 'cameras/cameraZoomed',
        title: 'Camera Zoomed',
        eventData: eventData.camera.zoom
    },
    'cameras/cameraAudioDetectionDisabled': {
        eventName: 'cameras/cameraAudioDetectionDisabled',
        title: 'Camera Audio Detection Disabled'
    },
    'cameras/cameraAudioDetectionSet': {
        eventName: 'cameras/cameraAudioDetectionSet',
        title: 'Camera Audio Detection Set'
    },
    'cameras/cameraAudioDetectionEnabled': {
        eventName: 'cameras/cameraAudioDetectionEnabled',
        title: 'Camera Audio Detection Enabled'
    },
    'cameras/cameraAudioFinished': {
        eventName: 'cameras/cameraAudioFinished',
        title: 'Camera Audio Finished'
    },
    'cameras/audio': {
        eventName: 'cameras/audio',
        title: 'Audio Detected'
    },
    'cameras/cameraAudioRegularUpdate': {
        eventName: 'cameras/cameraAudioRegularUpdate',
        title: 'Camera Audio Regular Update'
    },
    'cameras/cameraAudioStarted': {
        eventName: 'cameras/cameraAudioStarted',
        title: 'Camera Audio Started'
    },
    'cameras/cameraAudioSettingsSet': {
        eventName: 'cameras/cameraAudioSettingsSet',
        title: 'Camera Audio SettingsSet'
    },
    'cameras/cameraMissingVideo': {
        eventName: 'cameras/cameraMissingVideo',
        title: 'Camera Missing Video',
        eventData: eventData.camera.missingVideo
    },
    'cameras/cameraSetPTZHome': {
        eventName: 'cameras/cameraSetPTZHome',
        title: 'Camera Set PTZ Home'
    },
    'cameras/cameraSetPTZIdleTimeout': {
        eventName: 'cameras/cameraSetPTZIdleTimeout',
        title: 'Camera Set PTZ Idle Timeout'
    },
    'cameras/video': {
        eventName: 'cameras/video',
        title: 'New Video'
    },
    'cameras/online': {
        eventName: 'cameras/online',
        title: 'Camera Online'
    },
    'cameras/offline': {
        eventName: 'cameras/offline',
        title: 'Camera Offline',
        eventData: eventData.camera.offline
    },
    'cameras/status': {
        eventName: 'cameras/status',
        title: 'Camera Status'
    },
    'cameras/smallObject': {
        eventName: 'cameras/smallObject',
        title: 'Small Object Detected'
    },
    'cameras/human': {
        eventName: 'cameras/human',
        title: 'Human Detected'
    },
    'cameras/vehicle': {
        eventName: 'cameras/vehicle',
        title: 'Vehicle Detected'
    },
    'cameras/animal': {
        eventName: 'cameras/animal',
        title: 'Animal Detected'
    },
    'cameras/temperatureRegularUpdate': {
        eventName: 'cameras/temperatureRegularUpdate',
        title: 'Camera Temperature Regular Update'
    },
    'cameras/unknownObject': {
        eventName: 'cameras/unknownObject',
        title: 'Unknown Object Detected'
    },
    'cameras/timelapse': {
        eventName: 'cameras/timelapse',
        title: 'Timelapse Image'
    },
    'cameras/acknowledgement': {
        eventName: 'cameras/acknowledgement',
        title: 'cameras/acknowledgement'
    },
    'contact/open': {
        eventName: 'contact/open',
        title: 'Contact Open'
    },
    'contact/close': {
        eventName: 'contact/close',
        title: 'Contact Closed'
    },
    'contact/acknowledgement': {
        eventName: 'contact/acknowledgement',
        title: 'contact/acknowledgement'
    },
    'earthquakes/earthquake': {
        eventName: 'earthquakes/earthquake',
        title: 'New Earthquake',
        eventData: eventData.earthquake
    },
    'earthquakes/acknowledgement': {
        eventName: 'earthquakes/acknowledgement',
        title: 'earthquakes/acknowledgement'
    },
    'gates/cloudOpenSet': {
        eventName: 'gates/cloudOpenSet',
        title: 'Gates Cloud Open Set'
    },
    'gates/cloudCloseSet': {
        eventName: 'gates/cloudCloseSet',
        title: 'Gates Cloud Close Set'
    },
    'gates/gateOpened': {
        eventName: 'gates/gateOpened',
        title: 'Gate Opened'
    },
    'gates/gateClosed': {
        eventName: 'gates/gateClosed',
        title: 'Gate Closed'
    },
    'gates/cloudNormalModeSet': {
        eventName: 'gates/cloudNormalModeSet',
        title: 'Gates Cloud Normal Mode Set'
    },
    'gates/cloudHoldOpenModeSet': {
        eventName: 'gates/cloudHoldOpenModeSet',
        title: 'Gate Cloud Hold Open Mode Set'
    },
    'gates/cloudHoldCloseModeSet': {
        eventName: 'gates/cloudHoldCloseModeSet',
        title: 'Gate Cloud Hold Closed Mode Set'
    },
    'gates/accessSuccess': {
        eventName: 'gates/accessSuccess',
        title: 'Gate Cloud Hold Open Mode Set'
    },
    'gates/accessFailure': {
        eventName: 'gates/accessFailure',
        title: 'Gates Access Failure'
    },
    'gates/gateTampered': {
        eventName: 'gates/gateTampered',
        title: 'Gate Tampered'
    },
    'gates/gateReturnedToNormal': {
        eventName: 'gates/gateReturnedToNormal',
        title: 'Gate Returned to Normal'
    },
    'gates/acknowledgement': {
        eventName: 'gates/acknowledgement',
        title: 'gates/acknowledgement'
    },
    'gps/regularUpdate': {
        eventName: 'gps/regularUpdate',
        title: 'GPS Regular Update',
        eventData: eventData.gps
    },
    'gps/acknowledgement': {
        eventName: 'gps/acknowledgement',
        title: 'gps/acknowledgement'
    },
    'lpr/plate': {
        eventName: 'lpr/plate',
        title: 'License plate read',
        eventData: eventData.lpr
    },
    'lpr/ofInterest': {
        eventName: 'lpr/ofInterest',
        title: 'License plate of interest matched'
    },
    'lpr/matched': {
        eventName: 'lpr/matched',
        title: 'License plate matched',
        eventData: eventData.lpr
    },
    'lpr/acknowledgement': {
        eventName: 'lpr/acknowledgement',
        title: 'lpr/acknowledgement'
    },
    'axisNvr/status': {
        eventName: 'axisNvr/status',
        title: 'NVR Configuration Change',
        eventData: eventData.nvr
    },
    'axisNvr/misconfigured': {
        eventName: 'axisNvr/misconfigured',
        title: 'NVR Misconfigured'
    },
    'axisNvr/unreachable': {
        eventName: 'axisNvr/unreachable',
        title: 'NVR Unreachable'
    },
    'axisNvr/reachable': {
        eventName: 'axisNvr/reachable',
        title: 'NVR Reachable'
    },
    'axisNvr/recordingStarted': {
        eventName: 'axisNvr/recordingStarted',
        title: 'Camera Recording Started'
    },
    'axisNvr/recordingStopped': {
        eventName: 'axisNvr/recordingStopped',
        title: 'Camera Recording Stopped'
    },
    'axisNvr/diskError': {
        eventName: 'axisNvr/diskError',
        title: 'NVR Disk Error'
    },
    'axisNvr/diskWarning': {
        eventName: 'axisNvr/diskWarning',
        title: 'NVR Disk Warning'
    },
    'axisNvr/recordingFailCameraAccess': {
        eventName: 'axisNvr/recordingFailCameraAccess',
        title: 'NVR Camera Access Fail'
    },
    'axisNvr/recordingFailure': {
        eventName: 'axisNvr/recordingFailure',
        title: 'NVR Recording Fail'
    },
    'axisNvr/cameraStatusDown': {
        eventName: 'axisNvr/cameraStatusDown',
        title: 'NVR Camera Unreachable'
    },
    'axisNvr/cameraStatusUp': {
        eventName: 'axisNvr/cameraStatusUp',
        title: 'NVR Camera Reachable'
    },
    'axisNvr/acknowledgement': {
        eventName: 'axisNvr/acknowledgement',
        title: 'axisNvr/acknowledgement'
    },
    'padlocks/unlockedLock': {
        eventName: 'padlocks/unlockedLock',
        title: 'Unlocked',
        eventData: eventData.padlock
    },
    'padlocks/lockedLock': {
        eventName: 'padlocks/lockedLock',
        title: 'Locked',
        eventData: eventData.padlock
    },
    'padlocks/quickClickAssigned': {
        eventName: 'padlocks/quickClickAssigned',
        title: 'QuickClick Assigned'
    },
    'padlocks/quickClickDeleted': {
        eventName: 'padlocks/quickClickDeleted',
        title: 'QuickClick Deleted'
    },
    'padlocks/batteryLow': {
        eventName: 'padlocks/batteryLow',
        title: 'Battery Level Low',
        eventData: eventData.padlock
    },
    'padlocks/batteryCritical': {
        eventName: 'padlocks/batteryCritical',
        title: 'Battery Level Critical',
        eventData: eventData.padlock
    },
    'padlocks/acknowledgement': {
        eventName: 'padlocks/acknowledgement',
        title: 'padlocks/acknowledgement'
    },
    'pumps/modeCloud': {
        eventName: 'pumps/modeCloud',
        title: 'Pumps Mode Cloud'
    },
    'pumps/modeLocal': {
        eventName: 'pumps/modeLocal',
        title: 'Pumps Mode Local'
    },
    'pumps/cloudOn': {
        eventName: 'pumps/cloudOn',
        title: 'Pumps Cloud On'
    },
    'pumps/cloudOff': {
        eventName: 'pumps/cloudOff',
        title: 'Pumps Cloud Off'
    },
    'pumps/pumpOff': {
        eventName: 'pumps/pumpOff',
        title: 'Pump Off'
    },
    'pumps/pumpOn': {
        eventName: 'pumps/pumpOn',
        title: 'Pump On'
    },
    'pumps/pumpModeTimer': {
        eventName: 'pumps/pumpModeTimer',
        title: 'Pumps Mode Timer'
    },
    'pumps/killSwitchOn': {
        eventName: 'pumps/killSwitchOn',
        title: 'Kill Switch On'
    },
    'pumps/killSwitchOff': {
        eventName: 'pumps/killSwitchOff',
        title: 'Kill Switch Off'
    },
    'pumps/failOn': {
        eventName: 'pumps/failOn',
        title: 'Switch On Failure'
    },
    'pumps/failOff': {
        eventName: 'pumps/failOff',
        title: 'Switch Off Failure'
    },
    'pumps/switchAuto': {
        eventName: 'pumps/switchAuto',
        title: 'Switch Auto'
    },
    'pumps/switchHand': {
        eventName: 'pumps/switchHand',
        title: 'Switch Hand'
    },
    'pumps/switchOff': {
        eventName: 'pumps/switchOff',
        title: 'Switch Off'
    },
    'pumps/switchError': {
        eventName: 'pumps/switchError',
        title: 'Switch Error'
    },
    'pumps/acknowledgement': {
        eventName: 'pumps/acknowledgement',
        title: 'pumps/acknowledgement'
    },
    'sensors/regularUpdate': {
        eventName: 'sensors/regularUpdate',
        title: 'Sensors Regular Update'
    },
    'sensors/aggregated/minute': {
        eventName: 'sensors/aggregated/minute',
        title: 'Sensors Aggregated Minute'
    },
    'sensors/pointsChanged': {
        eventName: 'sensors/pointsChanged',
        title: 'Sensors Points Changed'
    },
    'sensors/pointChanged': {
        eventName: 'sensors/pointChanged',
        title: 'Sensors Point Changed'
    },
    'sensors/badGet': {
        eventName: 'sensors/badGet',
        title: 'Point Get Failed'
    },
    'sensors/badGetClear': {
        eventName: 'sensors/badGetClear',
        title: 'Point Get Clear'
    },
    'sensors/badSet': {
        eventName: 'sensors/badSet',
        title: 'Point Set Failed'
    },
    'sensors/badSetClear': {
        eventName: 'sensors/badSetClear',
        title: 'Point Set Clear'
    },
    'sensors/highThreshold': {
        eventName: 'sensors/highThreshold',
        title: 'Point High Threshold'
    },
    'sensors/highThresholdClear': {
        eventName: 'sensors/highThresholdClear',
        title: 'Point High Threshold Clear'
    },
    'sensors/lowThreshold': {
        eventName: 'sensors/lowThreshold',
        title: 'Point Low Threshold'
    },
    'sensors/lowThresholdClear': {
        eventName: 'sensors/lowThresholdClear',
        title: 'Point Low Threshold Clear'
    },
    'sensors/repeatedValue': {
        eventName: 'sensors/repeatedValue',
        title: 'Point Repeating'
    },
    'sensors/repeatedValueClear': {
        eventName: 'sensors/repeatedValueClear',
        title: 'Point Repeating Clear'
    },
    'sensors/calculationFail': {
        eventName: 'sensors/calculationFail',
        title: 'Unable to calculate'
    },
    'sensors/acknowledgement': {
        eventName: 'sensors/acknowledgement',
        title: 'sensors/acknowledgement'
    },
    'tanks/regularUpdate': {
        eventName: 'tanks/regularUpdate',
        title: 'Tanks Regular Update',
        eventData: eventData.tank
    },
    'tanks/levelHighStart': {
        eventName: 'tanks/levelHighStart',
        title: 'Level High Start',
        eventData: eventData.tank
    },
    'tanks/levelHighEnd': {
        eventName: 'tanks/levelHighEnd',
        title: 'Level High End',
        eventData: eventData.tank
    },
    'tanks/levelCriticalStart': {
        eventName: 'tanks/levelCriticalStart',
        title: 'Level Critical Start',
        eventData: eventData.tank
    },
    'tanks/levelCriticalEnd': {
        eventName: 'tanks/levelCriticalEnd',
        title: 'Level Critical End',
        eventData: eventData.tank
    },
    'tanks/rapidIncreaseStart': {
        eventName: 'tanks/rapidIncreaseStart',
        title: 'Rapid Increase Start',
        eventData: eventData.tank
    },
    'tanks/rapidIncreaseEnd': {
        eventName: 'tanks/rapidIncreaseEnd',
        title: 'Rapid Increase End',
        eventData: eventData.tank
    },
    'tanks/rapidDecreaseStart': {
        eventName: 'tanks/rapidDecreaseStart',
        title: 'Rapid Decrease Start',
        eventData: eventData.tank
    },
    'tanks/rapidDecreaseEnd': {
        eventName: 'tanks/rapidDecreaseEnd',
        title: 'Rapid Decrease End',
        eventData: eventData.tank
    },
    'tanks/lowBatteryStart': {
        eventName: 'tanks/lowBatteryStart',
        title: 'Low Battery Detected',
        eventData: eventData.tank
    },
    'tanks/lowBatteryEnd': {
        eventName: 'tanks/lowBatteryEnd',
        title: 'Battery is no longer low',
        eventData: eventData.tank
    },
    'tanks/manualHaulEntry': {
        eventName: 'tanks/manualHaulEntry',
        title: 'Manual Haul Entry',
        eventData: eventData.tank
    },
    'tanks/failStateOccured': {
        eventName: 'tanks/failStateOccured',
        title: 'Fail State Occurred',
        eventData: eventData.tank
    },
    'tanks/failStateCleared': {
        eventName: 'tanks/failStateCleared',
        title: 'Fail State Cleared',
        eventData: eventData.tank
    },
    'tanks/acknowledgement': {
        eventName: 'tanks/acknowledgement',
        title: 'tanks/acknowledgement',
        eventData: eventData.tank
    },
    'totalFlowMeters/totalFlowMeterRegularUpdate': {
        eventName: 'totalFlowMeters/totalFlowMeterRegularUpdate',
        title: 'TotalFlow Regular Update'
    },
    'totalFlowMeters/acknowledgement': {
        eventName: 'totalFlowMeters/acknowledgement',
        title: 'totalFlowMeters/acknowledgement'
    },
    'thermalTank/update': {
        eventName: 'thermalTank/update',
        title: 'Thermal Tank Update',
    },
    'thermalTank/detail': {
        eventName: 'thermalTank/detail',
        title: 'Detailed Zone Information',
        eventData: eventData.thermalTank
    },
    'thermalTank/acknowledgement': {
        eventName: 'thermalTank/acknowledgement',
        title: 'thermalTank/acknowledgement'
    },
    'tripwires/tripped': {
        eventName: 'tripwires/tripped',
        title: 'Tripwire Tripped'
    },
    'tripwires/blocked': {
        eventName: 'tripwires/blocked',
        title: 'Tripwire Blocked'
    },
    'tripwires/unblocked': {
        eventName: 'tripwires/unblocked',
        title: 'Tripwire Unblocked'
    },
    'tripwires/acknowledgement': {
        eventName: 'tripwires/acknowledgement',
        title: 'tripwires/acknowledgement'
    },
    'jobServers/acknowledgement': {
        eventName: 'jobServers/acknowledgement',
        title: 'jobServers/acknowledgement'
    },
    'shutoff/alarmStart': {
        eventName: 'shutoff/alarmStart',
        title: 'Alarm Start'
    },
    'shutoff/alarmEnd': {
        eventName: 'shutoff/alarmEnd',
        title: 'Alarm End'
    },
    'shutoff/warnStart': {
        eventName: 'shutoff/warnStart',
        title: 'Warning Start'
    },
    'shutoff/warnEnd': {
        eventName: 'shutoff/warnEnd',
        title: 'Warning End'
    },
    'shutoff/shutoffRegularUpdate': {
        eventName: 'shutoff/shutoffRegularUpdate',
        title: 'Shutoff Regular Update'
    },
    'shutoff/acknowledgement': {
        eventName: 'shutoff/acknowledgement',
        title: 'shutoff/acknowledgement'
    },
    'speakers/clipPlay': {
        eventName: 'speakers/clipPlay',
        title: 'Speakers Clip Play',
        eventData: eventData.speaker
    },
    'speakers/acknowledgement': {
        eventName: 'speakers/acknowledgement',
        title: 'speakers/acknowledgement'
    },
    'alarms/vfdAlarmStart': {
        eventName: 'alarms/vfdAlarmStart',
        title: 'VFD Alarm Start'
    },
    'alarms/vfdAlarmEnd': {
        eventName: 'alarms/vfdAlarmEnd',
        title: 'VFD Alarm End'
    },
    'alarms/runStatusStart': {
        eventName: 'alarms/runStatusStart',
        title: 'Run Status On'
    },
    'alarms/runStatusEnd': {
        eventName: 'alarms/runStatusEnd',
        title: 'Run Status Off'
    },
    'alarms/pocFaultStart': {
        eventName: 'alarms/pocFaultStart',
        title: 'POC Fault Start'
    },
    'alarms/pocFaultEnd': {
        eventName: 'alarms/pocFaultEnd',
        title: 'POC Fault End'
    },
    'alarms/alarmStart': {
        eventName: 'alarms/alarmStart',
        title: 'Alarm Start'
    },
    'alarms/alarmEnd': {
        eventName: 'alarms/alarmEnd',
        title: 'Alarm End'
    },
    'alarms/acknowledgement': {
        eventName: 'alarms/acknowledgement',
        title: 'alarms/acknowledgement'
    },
    'manualDataEntry/dataSent': {
        eventName: 'manualDataEntry/dataSent',
        title: 'Sent new data'
    },
    'manualDataEntry/acknowledgement': {
        eventName: 'manualDataEntry/acknowledgement',
        title: 'manualDataEntry/acknowledgement'
    },
    'genetec/accessGranted': {
        eventName: 'genetec/accessGranted',
        title: 'Access Granted'
    },
    'genetec/accessRefused': {
        eventName: 'genetec/accessRefused',
        title: 'Access Refused'
    },
    'genetec/doorOpen': {
        eventName: 'genetec/doorOpen',
        title: 'Door Opened'
    },
    'genetec/doorClose': {
        eventName: 'genetec/doorClose',
        title: 'Door Closed'
    },
    'genetec/doorLock': {
        eventName: 'genetec/doorLock',
        title: 'Door Locked'
    },
    'genetec/doorUnlock': {
        eventName: 'genetec/doorUnlock',
        title: 'Door Unlocked'
    },
    'genetec/acknowledgement': {
        eventName: 'genetec/acknowledgement',
        title: 'genetec/acknowledgement'
    },
    'emergencyGps/911': {
        eventName: 'emergencyGps/911',
        title: 'S.O.S.'
    },
    'emergencyGps/ok': {
        eventName: 'emergencyGps/ok',
        title: 'OK'
    },
    'emergencyGps/911Cancel': {
        eventName: 'emergencyGps/911Cancel',
        title: 'S.O.S. Cancel'
    },
    'emergencyGps/911Cancelemergency': {
        eventName: 'emergencyGps/911Cancelemergency',
        title: 'Cancel S.O.S., Help'
    },
    'emergencyGps/911CancelemergencyCancel': {
        eventName: 'emergencyGps/911CancelemergencyCancel',
        title: 'Cancel S.O.S., Cancel Help'
    },
    'emergencyGps/911CancelunauthorizedMove': {
        eventName: 'emergencyGps/911CancelunauthorizedMove',
        title: 'Both S.O.S. Cancel and Unauthorized Movement'
    },
    'emergencyGps/911Emergency': {
        eventName: 'emergencyGps/911Emergency',
        title: 'Both S.O.S. and Help'
    },
    'emergencyGps/911EmergencyCancel': {
        eventName: 'emergencyGps/911EmergencyCancel',
        title: 'S.O.S., Cancel Help'
    },
    'emergencyGps/911UnauthorizedMove': {
        eventName: 'emergencyGps/911UnauthorizedMove',
        title: 'Both S.O.S. and Unauthorized Movement'
    },
    'emergencyGps/911UnauthorizedMoveCancel': {
        eventName: 'emergencyGps/911UnauthorizedMoveCancel',
        title: 'Both S.O.S. and Unauthorized Movement Cancel'
    },
    'emergencyGps/custom': {
        eventName: 'emergencyGps/custom',
        title: 'Custom'
    },
    'emergencyGps/dailyStatus': {
        eventName: 'emergencyGps/dailyStatus',
        title: 'Daily Status'
    },
    'emergencyGps/emergency': {
        eventName: 'emergencyGps/emergency',
        title: 'Emergency'
    },
    'emergencyGps/emergencyCancel': {
        eventName: 'emergencyGps/emergencyCancel',
        title: 'Emergency cancelled'
    },
    'emergencyGps/emergencyunauthorizedMove': {
        eventName: 'emergencyGps/emergencyunauthorizedMove',
        title: 'Both Help and Unauthorized Movement'
    },
    'emergencyGps/poi': {
        eventName: 'emergencyGps/poi',
        title: 'Reference Point'
    },
    'emergencyGps/powerChange': {
        eventName: 'emergencyGps/powerChange',
        title: 'Power Status Change'
    },
    'emergencyGps/sensorAlarm': {
        eventName: 'emergencyGps/sensorAlarm',
        title: 'Sensor Alert'
    },
    'emergencyGps/sensorAlarmClear': {
        eventName: 'emergencyGps/sensorAlarmClear',
        title: 'Sensor Alert Clear'
    },
    'emergencyGps/test': {
        eventName: 'emergencyGps/test',
        title: 'Check In'
    },
    'emergencyGps/track': {
        eventName: 'emergencyGps/track',
        title: 'Track'
    },
    'emergencyGps/unauthorizedMove': {
        eventName: 'emergencyGps/unauthorizedMove',
        title: 'Unauthorized Movement'
    },
    'emergencyGps/unauthorizedMoveCancel': {
        eventName: 'emergencyGps/unauthorizedMoveCancel',
        title: 'Unauthorized Movement Cancel'
    },
    'emergencyGps/newmovement': {
        eventName: 'emergencyGps/newmovement',
        title: 'New Movement'
    },
    'emergencyGps/unlimitedTrack': {
        eventName: 'emergencyGps/unlimitedTrack',
        title: 'Unlimited Track'
    },
    'emergencyGps/extremeTrack': {
        eventName: 'emergencyGps/extremeTrack',
        title: 'Extreme Track'
    },
    'emergencyGps/powerOff': {
        eventName: 'emergencyGps/powerOff',
        title: 'Power Off'
    },
    'emergencyGps/stop': {
        eventName: 'emergencyGps/stop',
        title: 'Stop'
    },
    'emergencyGps/status': {
        eventName: 'emergencyGps/status',
        title: 'Status'
    },
    'emergencyGps/help': {
        eventName: 'emergencyGps/help',
        title: 'Help'
    },
    'emergencyGps/helpCancel': {
        eventName: 'emergencyGps/helpCancel',
        title: 'Help cancelled'
    },
    'emergencyGps/acknowledgement': {
        eventName: 'emergencyGps/acknowledgement',
        title: 'emergencyGps/acknowledgement'
    },
    'ticketingSwd/transaction': {
        eventName: 'ticketingSwd/transaction',
        title: 'ticketingSwd/transaction',
        eventData: eventData.ticketingSwd
    },
    'ticketingSwd/wellSync': {
        eventName: 'ticketingSwd/wellSync',
        title: 'Well Sync'
    },
    'ticketingSwd/acknowledgement': {
        eventName: 'ticketingSwd/acknowledgement',
        title: 'ticketingSwd/acknowledgement'
    },
    'toptech/transaction': {
        eventName: 'toptech/transaction',
        title: 'toptech/transaction',
        eventData: eventData.toptech
    },
    'toptech/acknowledgement': {
        eventName: 'toptech/acknowledgement',
        title: 'toptech/acknowledgement',
        eventData: eventData.toptech
    },
    'rcu/online': {
        eventName: 'rcu/online',
        title: 'RCU Online'
    },
    'rcu/status': {
        eventName: 'rcu/status',
        title: 'RCU Status'
    },
    'rcu/acknowledgement': {
        eventName: 'rcu/acknowledgement',
        title: 'rcu/acknowledgement'
    }
};
export default supportedEventConditions;
